<template>
  <div
    class="map-wrapper"
    :class="{
      'map-wrapper-nosidebar': isNoSideBar
    }">
    <h3>Damages</h3>
    <router-link :to="{name: 'Damage'}">
      <b-button>
        <b-icon icon="menu"/> &nbsp; Damage List
      </b-button>
    </router-link>
    <router-link :to="{name: 'Damage:Create'}">
      <b-button>
        <b-icon icon="plus"/> &nbsp; Report
      </b-button>
    </router-link>
    <br/>
    <br/>
    <LMap
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
      >
      <LTileLayer :url="url" :attribution="attribution" />
      <LMarker
        v-for="s in damages"
        :key="s._id"
        :lat-lng="getLatLng(s.location)">
        <LTooltip :options="{ permanent: true, interactive: true }">
          <div>
            Name: {{s.name}}<br/>
            Type: {{s.type}}<br/>
            Time: {{s.time}}<br/>
            Casualties: {{s.casualties.death}} death(s)<br/>
          </div>
        </LTooltip>
      </LMarker>
    </LMap>
  </div>
</template>

<style lang="scss" scoped>
.map {
  &-wrapper {
    position: absolute;
    top: 50px;
    bottom: 20px;
    right: 0px;
    padding: 20px;
    height: 85vh;
    left: 0px;

    @media only screen and (min-width: 768px) {
      left: 300px;
    }

    &-nosidebar {
      left: 0px;
    }
  }
}
</style>

<script>
import {mapGetters, mapActions} from 'vuex'
import {latLng} from 'leaflet'
import {LMap, LTileLayer, LMarker, LTooltip} from 'vue2-leaflet'

const DEFAULT_CENTER = latLng(-0.599094, 117.504444)

export default {
  name: 'ShelterStatus',
  data () {
    return {
      isNoSideBar: false,
      zoom: 5,
      center: DEFAULT_CENTER,
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      attribution:
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      marker: DEFAULT_CENTER,
      mapOptions: {
        zoomSnap: 0.5
      },
      currentZoom: 0,
      currentCenter: 0
    }
  },
  mounted () {
    this.init()
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip
  },
  computed: {
    ...mapGetters(['visibleSideBar']),
    ...mapGetters('Damage', ['damages'])
  },
  methods: {
    ...mapActions('Damage', {
      fetchDamages: 'fetch'
    }),
    zoomUpdate(zoom) {
      this.currentZoom = zoom
    },
    centerUpdate(center) {
      this.currentCenter = center
      this.marker = center
    },
    init () {
      this.currentZoom = this.zoom
      this.currentCenter = this.center

      // fetch damages
      this.fetchDamages()
    },
    getLatLng (str) {
      return latLng(...str.split(','))
    },
    getStatus (code) {
      return this.statusMapped[code] || {}
    }
  },
  watch: {
    visibleSideBar (v) {
      if (v) {
        this.isNoSideBar = false
        return
      }

      setTimeout(() => {
        this.isNoSideBar = true
      }, 600)
    }
  }
}
</script>
